import { Injectable } from '@angular/core'
import { Loader } from '@googlemaps/js-api-loader'
import { ReplaySubject } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from '../../environments/environment'
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';

@Injectable({
    providedIn: 'root'
})
export class GoogleMapsService {
    private _Map: typeof google.maps.Map
    private _apiLoaded$ = new ReplaySubject(1)
    private _markerClusterer: MarkerClusterer | null = null;
    private _superClusterAlgorithm: SuperClusterAlgorithm
    markers: google.maps.marker.AdvancedMarkerElement[] = []
    activeMarker: google.maps.marker.AdvancedMarkerElement | null
    activeListing: string

    constructor() {
        const loader = new Loader({
            apiKey: environment.maps.key,
            version: 'weekly',
            libraries: ['places', 'marker', 'geometry']
        })

        loader.importLibrary('maps')
            .then(({ Map }) => {
                this._Map = Map
                this._apiLoaded$.next()
            })
            .catch(e => {
                console.error(e)
            })
    }

    createMap(domElement: HTMLElement, options: google.maps.MapOptions) {
        return this._apiLoaded$
            .pipe(map(() => new this._Map(domElement, options)))
    }

    createMapInstance() {
        return this._apiLoaded$
            .pipe(map(() => this._Map))
    }

    initializeClusterer(map: google.maps.Map, markers: google.maps.marker.AdvancedMarkerElement[], renderer) {
        this.clearClusterer()
        this._markerClusterer = new MarkerClusterer({ 
            map, 
            markers,
            renderer,
            algorithm: new SuperClusterAlgorithm({minPoints: 3})
        })
    }

    clearClusterer() {
        if (this._markerClusterer) {
            this._markerClusterer.clearMarkers();
        }
    }
}
